var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 30,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3432 47.27C35.4958 47.27 29.647 48.3495 29.647 52.6679C29.647 56.9878 35.4593 58.1055 42.3432 58.1055C49.1907 58.1055 55.0395 57.0275 55.0395 52.7076C55.0395 48.3877 49.2288 47.27 42.3432 47.27Z",
    fill: "#A0A3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.3431 43.1566C47.0076 43.1566 50.7449 39.4177 50.7449 34.7548C50.7449 30.092 47.0076 26.3531 42.3431 26.3531C37.6803 26.3531 33.9414 30.092 33.9414 34.7548C33.9414 39.4177 37.6803 43.1566 42.3431 43.1566Z",
    fill: "#A0A3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfile);
export default __webpack_public_path__ + "static/media/EmptyProfile.df45401d06ffd0b2595238ae6034a4fa.svg";
export { ForwardRef as ReactComponent };